<page-header
    icon="{{['MENUES', 'PAGE_PERFORMANCE'] | monIcons}}"
    header="{{'Performance Profiles' | translate}}"
    subHeader="{{'Lists all profiles available for your account' | translate}}">
    <page-header-content>
        <div class="text-right">
            <button type="button"
                    class="btn btn-border-radius btn-secondary"
                    (click)="openProfile()">
                {{ 'Add profile' | translate }}
            </button>
        </div>
    </page-header-content>
</page-header>

<div class="card panel-monsido-card profile-archive">
    <div class="card-header" *ngIf="showHeading">
        <div class="d-flex justify-content-between">
            <mon-tabs
                    [options]="tabs"
                    [status]="activeTab"
                    (onStatus)="onStatus($event)"
            >
            </mon-tabs>
            <div class="d-flex justify-content-end align-items-center my-2">
                <span class="fas fa-fw fa-question-circle mr-1"
                      aria-hidden="true"
                      [ngbTooltip]="'Shows the remaining number of Performance Profiles that can be created for this account' | translate"
                      triggers="focus hover">
                </span>
                <p class="my-0" *ngIf="getAvailableProfiles()">
                    {{ getAvailableProfilesText() }}
                </p>
                <p class="my-0" *ngIf="!getAvailableProfiles()">
                    {{ 'You have reached the maximum number of profiles for this account.' | translate }}
                </p>
            </div>
        </div>
    </div>
    <div class="card-body">
        <table-container
                         [noResultMessage]="'No Profiles were found' | translate"
                         [collection]="profiles"
                         (onPageChange)="onPageChange($event)"
                         (onPerPageChange)="onPageSizeChange($event)"
                         [progress]="promise">
            <table class="table table-hover table-fixed">
                <thead>
                <tr>
                    <th>{{ 'Name' | translate }}</th>
                    <th class="col-6">
                        &nbsp;
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let profile of profiles">
                    <td>
                        <p class="text-bold">{{profile.name}}</p>
                        <p *ngIf="profile.description">{{profile.description}}</p>
                    </td>
                    <td class="text-right">
                        <mon-action-menu [monActionMenuItems]="profile.dropdown">
                            <span>{{ 'Action' | translate }}</span>
                        </mon-action-menu>
                    </td>
                </tr>
                </tbody>
            </table>
        </table-container>
    </div>
</div>
